import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Personal Profile"),
  /*#__PURE__*/_createElementVNode("div", { class: "muted" }, "Please fill your personal details.")
], -1)
const _hoisted_3 = { class: "pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonalDetailsForm = _resolveComponent("PersonalDetailsForm")!
  const _component_OwnerAddressForm = _resolveComponent("OwnerAddressForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PersonalDetailsForm, {
        values: _ctx.values,
        onInput: _ctx.handleInput
      }, null, 8, ["values", "onInput"]),
      _createVNode(_component_OwnerAddressForm, {
        values: _ctx.values,
        country: _ctx.values.country,
        state: _ctx.values.state,
        colClass: "d-inline-flex gap-3",
        formLabels: _ctx.formLabels,
        onCountryChange: _ctx.handleCountryChange,
        onCountryBlur: _ctx.handleCountryBlur,
        onStateChange: _ctx.handleStateChange,
        onStateBlur: _ctx.handleStateBlur
      }, null, 8, ["values", "country", "state", "formLabels", "onCountryChange", "onCountryBlur", "onStateChange", "onStateBlur"])
    ])
  ]))
}